import makePayload from 'core/services/email/sendEmailFromAgent/singular/makePayload'
import sendEmailFromAgent from 'core/services/email/sendEmailFromAgent'
import fetchJSONHandleError from 'utils/NET/fetchJSONHandleError'
import store from 'utils/store/withMiddleware'
import { sendEmailQuoteEvent } from 'core/services/email/blueshift/implementations/email-quote'

function detailsPlanFromAgent(
  { config, path, salesCenterAgent },
  valuesForm,
  agentInformation
) {
  const state = store.getState()
  const promises = [
    state.dentalPlanId &&
      fetchJSONHandleError({
        url: state.jsons[state.plans[state.dentalPlanId].jsonId]
      }),
    state.latitudeId &&
      fetchJSONHandleError({
        url: state.jsons[state.plans[state.latitudeId].jsonId]
      })
  ]

  Promise.all(promises).then(([dentalJson, latitudeJson]) => {
    const data = makePayload({
      placement: config.placement,
      salesCenterAgent,
      valuesForm,
      agentInformation,
      dentalJson,
      latitudeJson,
      path
    })

    const quote = data.message.global_merge_vars.find(item => item.name === 'plan')
      .content.link

    sendEmailQuoteEvent(quote)

    sendEmailFromAgent({
      config,
      data
    })
  })
}

export default detailsPlanFromAgent
